module.exports = __webpack_public_path__ + "img/deffectiveReport.371a77ae.png";